import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react'
import GeneralContext from '../../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import styles from '../../services/styles'
import { Button, Progress, Rate } from 'antd';
import { displayMessage } from '../../services/helper';
import * as faceapi from 'face-api.js';
import EEventTypes from '../../enums/EEventTypes';
import EMotivationPhrases from '../../enums/EMotivationPhrases';
import useSound from 'use-sound'
import openlipAlert from '../../gameEventsSongs/openlipAlert.wav'

//importação dos sons a serem utilizados nos eventos
import eventAlert1 from '../../gameEventsSongs/alert1.wav'
import eventAlert2 from '../../gameEventsSongs/alert1.wav'
import eventAlert3 from '../../gameEventsSongs/alert1.wav'
import eventAlert4 from '../../gameEventsSongs/alert1.wav'
import eventAlert5 from '../../gameEventsSongs/alert1.wav'
import eventAlert6 from '../../gameEventsSongs/alert1.wav'
import eventAlert7 from '../../gameEventsSongs/alert1.wav'

// import * as tf from '@tensorflow/tfjs';
// import * as cocoSsd from '@tensorflow-models/coco-ssd';

let open_lip = 0

// const FaceMesh = window.FaceMesh;
// const Camera = window.Camera;
// const drawConnectors = window.drawConnectors;
// const FACEMESH_TESSELATION = window.FACEMESH_TESSELATION;
// const FACEMESH_RIGHT_EYE = window.FACEMESH_RIGHT_EYE;
// const FACEMESH_RIGHT_EYEBROW = window.FACEMESH_RIGHT_EYEBROW;
// const FACEMESH_LEFT_EYE = window.FACEMESH_LEFT_EYE;
// const FACEMESH_LEFT_EYEBROW = window.FACEMESH_LEFT_EYEBROW;
// const FACEMESH_FACE_OVAL = window.FACEMESH_FACE_OVAL;
// const FACEMESH_LIPS = window.FACEMESH_LIPS;

// const intersects = window.intersects;
// let objectDetectionModel = false;
// let tensorFlowModel;

const initialIncentiveMessageInfo = {
    incentiveMessage: '',
    exibitionTime: 0,
    backgroundColor: ''
}


export default function MonitoryAndExerciseRoom({ is_exercise_room }) {
    const { tc2 } = styles
    const {setShowLoading, windowWidth, user, mobile_mode} = useContext(GeneralContext)

    const [currentDialyControlData, setCurrentDialyControlData] = useState(null)
    const [patientDetected, setPatientDetected] = useState(false)
    const [progress, setProgress] = useState(0)
    const [timerRunning, setTimerRunning] = useState(false)
    const [currentMotivationalPhrase, setCurrentMotivationalPhrase] = useState(0)

    //funções para tocar os sons dos eventos
    const [playOpenLipAlert] = useSound(openlipAlert)
    const [playEventAlert1] = useSound(eventAlert1)
    const [playEventAlert2] = useSound(eventAlert2)
    const [playEventAlert3] = useSound(eventAlert3)
    const [playEventAlert4] = useSound(eventAlert4)
    const [playEventAlert5] = useSound(eventAlert5)
    const [playEventAlert6] = useSound(eventAlert6)
    const [playEventAlert7] = useSound(eventAlert7)

    // estados para indicar se é pra tocar o som ou não
    const [playAlertAfterInfraction, setPlayAlertAfterInfraction] = useState(false)
    
    const [currentDurationSection, setCurrentDurationSection] = useState(0)
   // const [inputValue, setInputValue] = useState('');
    const [maximumLipDistance, setMaximumLipDistance] = useState(4); // Defina a distância mínima para considerar os lábios abertos
    const maximumLipDistanceRef = useRef(maximumLipDistance);
    const [consecutiveInfractions, setConsecutiveInfractions] = useState(0);
    const videoRef = useRef(null);
    const [statusbarLength, setStatusbarLength] = useState(0);
    //const [shouldUseObjectDetection, setShouldUseObjectDetection] = useState(false);
    const [ruleConfig, setRuleConfig] = useState(null)
    const isLandscapeOrMobileMode = windowWidth < 1000
    const [currentIncentiveMessageInfo, setCurrentIncentiveMessageInfo] = useState(initialIncentiveMessageInfo)



    const jsonRules = `{
        "etapas": [
            {
                "cor_rgb": [255, 0, 0],
                "ordem": 1,
                "niveis_internos": 6,
                "tempo_por_etapa_em_segundos": 10,
                "quantidade_de_mangos_por_etapa": 0.2,
                "quantidade_de_erros_para_cair_de_etapa": 1,
                "mensagem_internal_level_up": [
                    { 
                        "mensagem": ${displayMessage('LVELUP_MESSAGE_1')}
                    },
                    {
                        "mensagem": ${displayMessage('LVELUP_MESSAGE_2')}
                    }
                ],
                "mensagem_internal_level_down": [
                    { 
                        "mensagem": ${displayMessage('LVELDOWN_MESSAGE_1')}
                    },
                    {
                        "mensagem": ${displayMessage('LEVELDOWN_MESSAGE_2')}
                    }
                ]
            },
            {
                "cor_rgb": [255, 136, 0],
                "ordem": 2,
                "niveis_internos": 5,
                "tempo_por_etapa_em_segundos": 10,
                "quantidade_de_mangos_por_etapa": 0.4,
                "quantidade_de_erros_para_cair_de_etapa": 1,
                "mensagem_internal_level_up": [
                    { 
                        "mensagem": ${displayMessage('LVELUP_MESSAGE_1')}
                    },
                    {
                        "mensagem": ${displayMessage('LVELUP_MESSAGE_2')}
                    }
                ],
                "mensagem_internal_level_down": [
                    { 
                        "mensagem": ${displayMessage('LVELDOWN_MESSAGE_1')}
                    },
                    {
                        "mensagem": ${displayMessage('LVELDOWN_MESSAGE_3')}
                    }
                ]
            },
            {
                "cor_rgb": [255, 234, 0],
                "ordem": 3,
                "niveis_internos": 4,
                "tempo_por_etapa_em_segundos": 10,
                "quantidade_de_mangos_por_etapa": 0.6,
                "quantidade_de_erros_para_cair_de_etapa": 1,
                "mensagem_internal_level_up": [
                    { 
                        "mensagem": ${displayMessage('LVELUP_MESSAGE_1')}
                    },
                    {
                        "mensagem": ${displayMessage('LVELUP_MESSAGE_2')}
                    }
                ],
                "mensagem_internal_level_down": [
                    { 
                        "mensagem": ${displayMessage('LVELDOWN_MESSAGE_1')}
                    },
                    {
                        "mensagem": ${displayMessage('LEVELDOWN_MESSAGE_2')}
                    }
                ]
            },
            {
                "cor_rgb": [168, 255, 0],
                "ordem": 4,
                "niveis_internos": 3,
                "tempo_por_etapa_em_segundos": 10,
                "quantidade_de_mangos_por_etapa": 0.8,
                "quantidade_de_erros_para_cair_de_etapa": 1,
                "mensagem_internal_level_up": [
                    { 
                        "mensagem": ${displayMessage('LVELUP_MESSAGE_1')}
                    },
                    {
                        "mensagem": ${displayMessage('LVELUP_MESSAGE_2')}
                    }
                ],
                "mensagem_internal_level_down": [
                    { 
                        "mensagem": ${displayMessage('LVELDOWN_MESSAGE_1')}
                    },
                    {
                        "mensagem": ${displayMessage('LEVELDOWN_MESSAGE_2')}
                    }
                ]
            },
            {
                "cor_rgb": [0, 240, 255],
                "ordem": 5,
                "niveis_internos": 2,
                "tempo_por_etapa_em_segundos": 10,
                "quantidade_de_mangos_por_etapa": 1,
                "quantidade_de_erros_para_cair_de_etapa": 1,
                "mensagem_internal_level_up": [
                    { 
                        "mensagem": ${displayMessage('LVELUP_MESSAGE_1')}
                    },
                    {
                        "mensagem": ${displayMessage('LVELUP_MESSAGE_2')}
                    }
                ],
                "mensagem_internal_level_down": [
                    { 
                        "mensagem": ${displayMessage('LVELDOWN_MESSAGE_1')}
                    },
                    {
                        "mensagem": ${displayMessage('LEVELDOWN_MESSAGE_2')}
                    }
                ]
            }
        ],
        "general_msgs": {
            "face_not_detected": [
                {
                    "mensagem": ${displayMessage('WARNING_NO_FACE_DETECTED')}
                }
            ],
            "open_lip": [
                {
                    "mensagem": ${displayMessage('WARNING_OPEN_LIP')}
                }
            ],
            "raise_head": [
                {
                    "mensagem": ${displayMessage('WARNING_RAISE_HEAD')}
                }
            ],
            "lower_head": [
                {
                    "mensagem": ${displayMessage('WARNING_LOWER_HEAD')}
                }
            ],
            "mouth_not_detected": [
                {
                    "mensagem": ${displayMessage('WARNING_MOUTH_NOT_DETECTED')}
                }
            ]
        }
    }`;

    async function getRuleConfig() {
        setShowLoading(true)
        try {
            const { data } = await api.config.list() 
            setRuleConfig(data[0].rule_for_time_bar)
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }
    const rules = ruleConfig != null ? JSON.parse(ruleConfig).etapas.sort((a, b) => a.ordem - b.ordem) : [];
    const general_msgs = ruleConfig != null && JSON.parse(ruleConfig).general_msgs;
    
    const [currentStage, setCurrentStage] = useState(0);
    const [currentInfractions, setCurrentInfractions] = useState(0);
    const [currentMangos, setCurrentMangos] = useState(0);
    const [currentInternalLevel, setCurrentInternalLevel] = useState(1);
    const seconds_for_stage = rules.length > 0 ? rules[currentStage]?.tempo_por_etapa_em_segundos : 0
    const [currentSeconds, setCurrentSeconds] = useState(seconds_for_stage);

    let last_verify_infraction_time = 0
    let min_interval = 5000
    //const maximumLipDistance = 5;  // Defina a distância mínima para considerar os lábios abertos
    let mustDrawFaceLandmarks = true
    let mustDrawObjectDetection = true
    const startWhenOpenPageFirst = useRef(false);
    const canvasElement = document.createElement('canvas');
    let currentConsecutiveInfractions = 0;
    
    

    // -------- Status Bar Variables and Methods ----------
    useEffect(() => {
        if (videoRef.current) {
            setStatusbarLength(videoRef.current.offsetWidth);
        }
    }, [videoRef.current?.offsetWidth]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSeconds(prevSeconds => prevSeconds - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    // Hook that handles the timer reaching zero
    useEffect(() => {
        if (currentSeconds <= 0 && rules.length > 0) {
            if (currentInternalLevel < rules[currentStage]?.niveis_internos) {
                // If there are still internal levels left, increase the internal level
                setCurrentInternalLevel(prevLevel => prevLevel + 1);
                createNewGameEvent("Internal Level Up");
            } else if (currentStage < rules.length - 1) {
                // If all internal levels are completed and it's not the last stage, move to the next stage and reset the internal level
                setCurrentStage(prevStage => prevStage + 1);
                setCurrentInternalLevel(1);
                createNewGameEvent("Stage Up")
            }
            // Give the user mangos for reaching a new internal level
            setCurrentMangos(prevMangos => prevMangos + rules[currentStage]?.quantidade_de_mangos_por_etapa);
            createNewGameEvent("Mangos")
            
            // Reset the timer
            setCurrentSeconds(rules[currentStage]?.tempo_por_etapa_em_segundos);
        }
    }, [currentSeconds]);

    // UseEffect hook that handles infractions
    useEffect(() => {
        if (rules.length > 0 && currentInfractions >= rules[currentStage]?.quantidade_de_erros_para_cair_de_etapa) {
            if (currentInternalLevel > 1) {
                // If there are internal levels to go back to, decrease the internal level
                setCurrentInternalLevel(prevLevel => prevLevel - 1);
                createNewGameEvent("Internal Level Down");
            } else if (currentStage > 0) {
                // If there are no internal levels left but there are stages to go back to, decrease the stage and set the internal level to the maximum
                setCurrentStage(prevStage => prevStage - 1);
                setCurrentInternalLevel(rules[currentStage]?.niveis_internos);
                createNewGameEvent("Stage Down");
            }

            // Reset the timer and the infractions
            setCurrentSeconds(rules[currentStage]?.tempo_por_etapa_em_segundos);
            setCurrentInfractions(0);
        }
    }, [currentInfractions]);

    // ------------------------------------------------------

    // Debug button to toggle the use of object detection
    // useEffect(() => {
    //     // This code will run whenever shouldUseObjectDetection changes
    //     if (shouldUseObjectDetection) {
    //         // Perform some action
    //         objectDetectionModel = shouldUseObjectDetection
    //         console.log('Object detection is enabled: ', shouldUseObjectDetection)
            
    //         // Usage of Object Detection tensorFlowModel
    //         if (tensorFlowModel) {
    //             tensorFlowModel.dispose();
    //         }
    //         cocoSsd.load().then(cocoModel => {
    //             tensorFlowModel = cocoModel;
    //         });
    //     } else {
    //         // Perform some other action
    //         objectDetectionModel = shouldUseObjectDetection
    //         console.log('Object detection is disabled: ', shouldUseObjectDetection)

    //         if (tensorFlowModel) {
    //             tensorFlowModel.dispose();
    //             tensorFlowModel = null;
    //         }
    //     }
    // }, [shouldUseObjectDetection]); // Adding shouldUseObjectDetection to the dependency array


    useEffect(() => {
        console.log('new maximumLipDistance:', maximumLipDistance);
        maximumLipDistanceRef.current = maximumLipDistance;
    }, [maximumLipDistance]);

    const handleChange = (event) => {
        const newValue = parseInt(event.target.value, 10);
        setMaximumLipDistance(newValue);
    };


    useEffect(() => {
        getCurrentDialy()
        getRuleConfig()
    }, [])
    
    useEffect(() => {
        const intervalId = setInterval(() => {
            showMotivationalPhrase()
        }, 5 * 60 * 1000)
        
        return () => {
            clearInterval(intervalId);
        };
    }, [currentMotivationalPhrase, patientDetected])

    useLayoutEffect(() => {
        const video = document.getElementById('video');
        const svg_cam_off = document.getElementById('svg-cam-off'); // New Stop Button
        const buttonStartAndFinish = document.getElementById('buttonStartAndFinish');
        let intervalId; // To store the setInterval ID for clearing later

        // --- FaceMesh variables ---
        // const faceMesh = null
        // const canvasCtx = null
        // -------------------------


        // --- FaceApi variables ---
        let lipClosedTime = 0;
        let lipOpenedTime = 0;
        let camera = null;
        // -------------------------

        async function setupFaceApi() {
            setShowLoading(true)
            try {
                await faceapi.nets.tinyFaceDetector.loadFromUri('https://unpkg.com/@vladmandic/face-api@1.7.1/model');
                await faceapi.nets.faceLandmark68Net.loadFromUri('https://unpkg.com/@vladmandic/face-api@1.7.1/model');
                setPatientDetected(true)
            } catch (error) {
                console.error('Error loading models:', error);
                setPatientDetected(false)
            } finally {
                setShowLoading(false)
            }
        }

        // async function setupFaceMesh() {
            
        //     console.log('Entrou na função setupFaceMesh')
        //     //const videoElement = document.getElementById('video');
            
        //     canvasElement.width = video.offsetWidth;
        //     canvasElement.height = video.offsetHeight;
        //     canvasElement.style.position = 'absolute';
        //     canvasElement.style.top = video.offsetTop + 'px';
        //     canvasElement.style.left = video.offsetLeft + 'px';
        //     video.parentElement.appendChild(canvasElement);
        //     canvasCtx = canvasElement.getContext('2d');

        //     window.addEventListener('resize', () => {
        //         canvasElement.width = video.offsetWidth;
        //         canvasElement.height = video.offsetHeight;
        //         canvasElement.style.top = video.offsetTop + 'px';
        //         canvasElement.style.left = video.offsetLeft + 'px';
        //     });


        //     faceMesh = new FaceMesh({locateFile: (file) => {
        //         return `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`;
        //     }});
    
        //     faceMesh.setOptions({
        //         maxNumFaces: 1,
        //         minDetectionConfidence: 0.05,   //Very low confidence to detect any object
        //         minTrackingConfidence: 0.05
        //     });
    
        //     faceMesh.onResults(onResults);

        // } //end of setupFaceMesh

        
        async function detectLipMovementWithFaceApi() {
            const displaySize = { width: video.videoWidth, height: video.videoHeight };


            // Create a canvas and append it to the body
            const canvas = faceapi.createCanvasFromMedia(video);
            // Copy the computed styles from the video to the canvas
            const videoStyles = window.getComputedStyle(video);
            canvas.style.position = 'absolute';
            canvas.style.top = videoStyles.getPropertyValue('top');
            canvas.style.left = videoStyles.getPropertyValue('left');
            canvas.style.width = videoStyles.getPropertyValue('width');
            canvas.style.height = videoStyles.getPropertyValue('height');
            video.parentElement.appendChild(canvas);
            // Match the display size
            faceapi.matchDimensions(canvas, displaySize);

            intervalId = setInterval(async () => {
                const detections = await faceapi.detectAllFaces(video, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks();
                const resizedDetections = faceapi.resizeResults(detections, displaySize);
                if (resizedDetections && resizedDetections.length > 0) {
                    setPatientDetected(true)
                    const landmarks = resizedDetections[0].landmarks;
                    const mouth = landmarks.getMouth();
                    

                    canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
                    // Draw the landmarks on the canvas
                    faceapi.draw.drawFaceLandmarks(canvas, resizedDetections);
                    // Get the landmarks

                    // Get the canvas context
                    const context = canvas.getContext('2d');
                    context.font = '10px Arial';
                    context.fillStyle = 'red';

                    // Draw the numbers
                    // landmarks.positions.forEach((position, index) => {
                    //     context.fillText(index, position.x, position.y);
                    // });

                    context.fillStyle = 'blue';
                    // mouth.forEach((position, index) => {
                    //     context.fillText(index, position.x, position.y);
                    // });
                    context.fillText(14, mouth[14].x, mouth[14].y);
                    context.fillText(18, mouth[18].x, mouth[18].y);
                    context.fillText(26, landmarks.positions[26].x, landmarks.positions[26].y);
                    context.fillText(16, landmarks.positions[16].x, landmarks.positions[16].y);
                  
                    

                    if ((landmarks.positions[26].y > landmarks.positions[16].y) || (landmarks.positions[17].y > landmarks.positions[0].y))
                    {
                        let time_now = Date.now()
                        if (time_now - last_verify_infraction_time >= min_interval) {
                            verifyInfraction("raise_head")
                            createNewGameEvent("Raise Head");
                            last_verify_infraction_time = Date.now()
                        }
                        return;
                    }
                    else if ((landmarks.positions[54].y < landmarks.positions[15].y) || (landmarks.positions[48].y < landmarks.positions[1].y))
                    {   
                        let time_now = Date.now()
                        if (time_now - last_verify_infraction_time >= min_interval) {
                            verifyInfraction("lower_head")
                            createNewGameEvent("Lower Head");
                            last_verify_infraction_time = Date.now()
                        }
                        return;
                    }


                    const headDist = Math.sqrt(
                        Math.pow(landmarks.positions[8].x - landmarks.positions[27].x, 2) +
                        Math.pow(landmarks.positions[8].y - landmarks.positions[27].y, 2)
                    );
                    const lipsDist = Math.sqrt(
                        Math.pow(mouth[18].x - mouth[14].x, 2) +
                        Math.pow(mouth[18].y - mouth[14].y, 2)
                    );
                    const lipsDistRatio = (100* lipsDist / headDist).toFixed(2);
                    const lipsOpenR = lipsDistRatio > maximumLipDistanceRef.current;
                    //console.log('lipsDist:' , lipsDist.toFixed(2), "|Ratio:", lipsDistRatio, "|headDist:",headDist.toFixed(2), "|:", lipsOpenR);
                    
                    if (lipsOpenR) {
                        let time_now = Date.now()
                        if (time_now - last_verify_infraction_time >= min_interval) {
                            verifyInfraction("open_lip")
                            last_verify_infraction_time = Date.now()
                            console.log('lipsDist: ', lipsOpenR);
                        }
                    
                        lipOpenedTime += 0.1;  // Adiciona 0.1 segundo (como este bloco é chamado a cada 100ms)
                        if (lipOpenedTime >= 2) {
                            lipOpenedTime = 0;  // Reset the opened time counter
                        }
                    } else {
                        lipClosedTime += 0.1;  // Adiciona 0.1 segundo (como este bloco é chamado a cada 100ms)
                        if (lipClosedTime >= 2) {
                            lipClosedTime = 0;  // Reset the closed time counter
                        }
                    }
                    currentConsecutiveInfractions = 0;
                } 
                else
                {

                    let time_now = Date.now()
                    currentConsecutiveInfractions += 1;
                    canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
                    if (currentConsecutiveInfractions >= 10) {
                        if (time_now - last_verify_infraction_time >= min_interval) 
                        {
                                //console.log('ResizeDetections is: ', resizedDetections, ' - Length:', resizedDetections.length);
                            verifyInfraction("face_not_detected")
                            last_verify_infraction_time = Date.now()
                            currentConsecutiveInfractions = 0;
                        }    
                    }
                }

            }, 100);
        }






        // async function detectLipMovementWithFaceMesh() {
        //     intervalId = setInterval(async () => {
        //         faceMesh.send({image: video});
        //     },1000);

        //     // camera = new Camera(video, {
        //     //     onFrame: async () => {
        //     //         await faceMesh.send({image: video});
        //     //     },
        //     //     width: video.offsetWidth,
        //     //     height: video.offsetHeight
        //     // });
    
        //     // camera.start();

        // }

        // async function onResults(results) {
        //     //console.log('Results ...face_not_detected');
        //     canvasCtx.save();
        //     canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
        //     canvasCtx.drawImage(results.image, 0, 0, canvasElement.width, canvasElement.height);

        //     if (results.multiFaceLandmarks) {
        //         if (results.multiFaceLandmarks.length < 1)  
        //         {
        //             let time_now = Date.now()
        //             if (time_now - last_verify_infraction_time >= min_interval) {
        //                     verifyInfraction("face_not_detected")
        //                     last_verify_infraction_time = Date.now()
        //             }    
        //         }
        //         for (const landmarks of results.multiFaceLandmarks) {
        //             if (mustDrawFaceLandmarks) {
        //                 drawConnectors(canvasCtx, landmarks, FACEMESH_TESSELATION,
        //                             {color: '#C0C0C070', lineWidth: 1});
        //                 drawConnectors(canvasCtx, landmarks, FACEMESH_RIGHT_EYE, {color: '#FF3030'});
        //                 drawConnectors(canvasCtx, landmarks, FACEMESH_RIGHT_EYEBROW, {color: '#FF3030'});
        //                 drawConnectors(canvasCtx, landmarks, FACEMESH_LEFT_EYE, {color: '#30FF30'});
        //                 drawConnectors(canvasCtx, landmarks, FACEMESH_LEFT_EYEBROW, {color: '#30FF30'});
        //                 drawConnectors(canvasCtx, landmarks, FACEMESH_FACE_OVAL, {color: '#E0E0E0'});
        //                 drawConnectors(canvasCtx, landmarks, FACEMESH_LIPS, {color: '#30FF30', lineWidth: 0.1}, );
        //             }
        //             const lipDistance = calculateLipDistance(landmarks);


        //             //console.log('LipDist:', lipDistance, ' - MaxDist:', maximumLipDistanceRef.current, ' - Consecutive:', currentConsecutiveInfractions);
        //             if (lipDistance > maximumLipDistanceRef.current) {
        //                 currentConsecutiveInfractions += 1;
        //                 if (currentConsecutiveInfractions >= 5) {
        //                     let time_now = Date.now()
        //                     if (time_now - last_verify_infraction_time >= min_interval) {
        //                         verifyInfraction("open_lip")
        //                         last_verify_infraction_time = Date.now()
        //                     }
        //                     currentConsecutiveInfractions = 0;
        //                 }
        //             } else {
        //                 currentConsecutiveInfractions = 0;
        //             }
                    
        //             if (objectDetectionModel)
        //             {
        //                 const faceBoundingBox = {
        //                     x: Math.min(...landmarks.map(p => p.x))* video.offsetWidth,
        //                     y: Math.min(...landmarks.map(p => p.y))* video.offsetHeight,
        //                     width: (Math.max(...landmarks.map(p => p.x)) - Math.min(...landmarks.map(p => p.x)))* video.offsetWidth,
        //                     height: (Math.max(...landmarks.map(p => p.y)) - Math.min(...landmarks.map(p => p.y)))* video.offsetHeight
        //                 };
        //                 const mouthBoundingBox = {
        //                     x: Math.min(landmarks[92].x, landmarks[424].x) * video.offsetWidth,
        //                     y: Math.min(landmarks[92].y, landmarks[424].y) * video.offsetHeight,
        //                     width: Math.abs(landmarks[92].x - landmarks[424].x) * video.offsetWidth,
        //                     height: Math.abs(landmarks[92].y - landmarks[424].y) * video.offsetHeight
        //                 };

    
        //                 if (mustDrawObjectDetection) {
        //                     canvasCtx.beginPath();
        //                     canvasCtx.rect(faceBoundingBox.x, faceBoundingBox.y, faceBoundingBox.width, faceBoundingBox.height);
        //                     canvasCtx.lineWidth = 2;
        //                     canvasCtx.strokeStyle = 'orange';
        //                     canvasCtx.stroke();

        //                     canvasCtx.beginPath();
        //                     canvasCtx.rect(mouthBoundingBox.x, mouthBoundingBox.y, mouthBoundingBox.width, mouthBoundingBox.height);
        //                     canvasCtx.lineWidth = 2;
        //                     canvasCtx.strokeStyle = 'yellow';
        //                     canvasCtx.stroke();
        //                 }
        //                 //console.log('Model: ', tensorFlowModel, ' - Video ready state: ', video.readyState === video.HAVE_ENOUGH_DATA);
        //                 if (tensorFlowModel && video.readyState === video.HAVE_ENOUGH_DATA) {
        //                     //console.log('Model is not null');
        //                     const predictions = await tensorFlowModel.detect(video);
        //                     for (let i = 0; i < predictions.length; i++) {
        //                         const objectArea = predictions[i].bbox[2] * predictions[i].bbox[3];
        //                         const faceArea = (faceBoundingBox.width) * (faceBoundingBox.height);
        //                         //console.log('Object area:', objectArea, ' - Face area:', faceArea, ' - Div:', objectArea / faceArea);
        
        //                         if (mustDrawObjectDetection)
        //                         {
        //                             // Draw the prediction box
        //                             const [x, y, width, height] = predictions[i].bbox;
        //                             canvasCtx.beginPath();
        //                             canvasCtx.rect(x, y, width, height);
        //                             canvasCtx.lineWidth = 2;
        //                             canvasCtx.strokeStyle = 'blue';
        //                             canvasCtx.fillStyle = 'blue';
        //                             canvasCtx.stroke();
        //                             canvasCtx.fillText(
        //                                 `${predictions[i].class} (${Math.round(predictions[i].score * 100)}%)`,
        //                                 x > canvasElement.width / 2 ? x - width : x + width,
        //                                 y > canvasElement.height / 2 ? y - height : y + height
        //                             );
        //                         }


        //                         if (intersects(mouthBoundingBox, predictions[i].bbox)) {
        //                             if (predictions[i].class !== 'person' || objectArea / faceArea < 1.0) 
        //                             {
        //                                 let time_now = Date.now()
        //                                 if (time_now - last_verify_infraction_time >= min_interval) {
        //                                     verifyInfraction("mouth_not_detected")
        //                                     last_verify_infraction_time = Date.now()
        //                                 }
        //                             }
        //                         }

        //                     }
        //                 }
        //             }
                    
        //         }
        //     }
        //     canvasCtx.restore();
        // }  //end of onResults





        // function calculateLipDistance(landmarks) {
        //     const upperLipPoint = landmarks[13];
        //     const lowerLipPoint = landmarks[14];

        //     const dx = upperLipPoint.x - lowerLipPoint.x;
        //     const dy = upperLipPoint.y - lowerLipPoint.y;

        //     return Math.sqrt(dx * dx + dy * dy) * 1000;
        // }

        // function isBlinking(landmarks) {
            
        //     // Calculate the euclidean distance between two points
        //     const distance = (a, b) => {
        //         const x = a.x - b.x;
        //         const y = a.y - b.y;
        //         return Math.sqrt(x * x + y * y);
        //     };
        
        //     // Calculate the eye aspect ratio
        //     const eyeAspectRatio = (points) => {
        //         const vertical1 = distance(landmarks[points[0]], landmarks[points[3]]);
        //         const vertical2 = distance(landmarks[points[1]], landmarks[points[2]]);
        //         const horizontal = distance(landmarks[points[0]], landmarks[points[1]]);
        //         return (vertical1 + vertical2) / (2.0 * horizontal);
        //     };
        
        //    // const leftEyePoints = [133, 362, 159, 145];
        //    // const rightEyePoints = [263, 33, 386, 374];
        //     const leftEyePoints = [33, 7, 163, 144, 145, 153, 154, 155, 133];
        //     const rightEyePoints = [362, 398, 384, 385, 386, 387, 388, 466];
        //     const leftEyeAspectRatio = eyeAspectRatio(leftEyePoints);

        //     const rightEyeAspectRatio = eyeAspectRatio(rightEyePoints);
        //     const averageAspectRatio = (leftEyeAspectRatio + rightEyeAspectRatio) / 2;
        
        //     const THRESHOLD = 0.2; // Adjust this value based on your specific requirements
        //     console.log('isBlinking:', averageAspectRatio);
        //     return averageAspectRatio < THRESHOLD;
        // }


        // function intersects(box1, box2) {
        //     return !(box2[0] > box1.x + box1.width || 
        //             box2[0] + box2[2] < box1.x || 
        //             box2[1] > box1.y + box1.height ||
        //             box2[1] + box2[3] < box1.y);
        // }



        function onCloseCamera(){
            if (video.srcObject) {
                video.srcObject.getTracks().forEach(track => track.stop())
                video.srcObject = null
            }
            clearInterval(intervalId)
            video.classList.add('hidden')
            svg_cam_off.classList.remove('hidden')
            setPatientDetected(false)
        }
        async function requestForOpenCamera() {
            setShowLoading(true)
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false })
                video.srcObject = stream
            } catch (error) {
                console.log(error)
            } finally {
                setShowLoading(false)
            }
        } 
        
        async function openCamera() {
            setShowLoading(true)
            try {
                console.log('entrou na função openCamera')
                const permission = await navigator.permissions.query({ name: 'camera' })
                console.log(permission)
                if (permission.state === 'denied') {
                    alert(displayMessage('ATTENTION_PERMISSION_VIDEO_DENIED'), 'info')
                    return 
                } 
                await requestForOpenCamera()
                //await setupFaceMesh()
                //detectLipMovementWithFaceMesh()
                await setupFaceApi()
                detectLipMovementWithFaceApi()
                
                video.classList.remove('hidden')
                svg_cam_off.classList.add('hidden')
                return true
            } catch (error) {
                console.log(error)
            } finally {
                setShowLoading(false)
            }
        }
        
        async function onClickButtonStartAndFinish() {
            setShowLoading(true)
            try {
                const current_dialy = await getCurrentDialy()
                if (!current_dialy) {
                    const is_camera_open = await openCamera()
                    if (is_camera_open) {
                        await handleOnStart()
                    } 
                } else {
                    onCloseCamera()
                    await handleOnFinish(current_dialy)
                }
            } catch (error) {
                console.log(error)
            } finally {
                setShowLoading(false)
            }
        }
        
        async function onStart() {
            setShowLoading(true)
            try {
                console.log('entrou na função onStart')
                const current_dialy = await getCurrentDialy()
                console.log('current_dialy:', current_dialy)
                const is_camera_open = await openCamera()
                if (!current_dialy && is_camera_open) {
                    await handleOnStart()
                }
            } catch (error) {
                console.log(error)
            } finally {
            setShowLoading(false)
            }
        }

        if (!startWhenOpenPageFirst.current) {
            console.log('entrou na função onStart 1')
            onStart()
            startWhenOpenPageFirst.current = true
        } else {
            console.log('entrou na função openCamera 1')
            openCamera()
        } 

        buttonStartAndFinish.addEventListener('click', onClickButtonStartAndFinish);
        return () => {
            buttonStartAndFinish.removeEventListener('click', onClickButtonStartAndFinish);
        };
    }, [])

    useEffect(() => {
        const updateData = async () => {
            if (currentDialyControlData && patientDetected) {
                await updateDialyOngoingDate()
            }
            await getCurrentDialy()
        };
    
        const intervalId = setInterval(updateData, 30000)
    
        return () => clearInterval(intervalId)
    }, [currentDialyControlData, patientDetected])
    
    useEffect(() => {
        let intervalId;
    
        const updateProgress = () => {
            const current_time = currentDialyControlData?.current_duration_formatted
            const section_time = 19
    
            if (current_time < section_time) {
                setProgress((current_time / section_time) * 100)
            } else {
                clearInterval(intervalId)
                finishTimer()
            }
        };
    
        if (timerRunning && patientDetected) {
            intervalId = setInterval(updateProgress, 30000)
        }
    
        return () => clearInterval(intervalId)
    }, [timerRunning, patientDetected, currentDialyControlData])

    // tocar sons dos eventos
    useEffect(() => {
        if (playAlertAfterInfraction) {
            playOpenLipAlert()
            setPlayAlertAfterInfraction(false)
        }
    }, [playAlertAfterInfraction, playOpenLipAlert])
    
    const showMotivationalPhrase = () => {
        if (currentMotivationalPhrase < EMotivationPhrases.length - 1) {
            setCurrentMotivationalPhrase(currentMotivationalPhrase + 1);
        }
    };

    async function verifyInfraction(infractionType) {
        try {
            console.log('Infraction Type is: ', infractionType)
            setPlayAlertAfterInfraction(true)
            setCurrentInfractions(prevInfractions => prevInfractions + 1)
            const current_dialy = await getCurrentDialy()
            if (current_dialy) {
                setShowLoading(true)
                const payload = {
                    id: current_dialy.id,
                    event_type: EEventTypes.OPEN_LIP.code
                }
                //!is_exercise_room ? await api.dialy_controls.addEventMonitory(payload) : await api.dialy_controls.addEventExercise(payload)
                open_lip = open_lip + 1 
            }
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }


    function startTimer() {
        setProgress(0);
        setTimerRunning(true);
    };

    function finishTimer() {
        setProgress(0);
        setTimerRunning(false);
    }

    async function createNewGameEvent(eventType) {
        let messages, randomIndex, randomMessage;
        if (rules.length > 0) {
            switch (eventType) {
                case 'Internal Level Up':
                    // Perform action for 'Internal Level Up'
                    messages = rules[currentStage].mensagem_internal_level_up;
                    randomIndex = Math.floor(Math.random() * messages.length);
                    randomMessage = messages[randomIndex].mensagem;
                    console.log(randomMessage);
                    playEventAlert1()
                    // playSound('Internal Level Up');
                    // playAnimation('Internal Level Up');
                    break;
                case 'Internal Level Down':
                    // Perform action for 'Internal Level Down'
                    messages = rules[currentStage].mensagem_internal_level_down;
                    randomIndex = Math.floor(Math.random() * messages.length);
                    randomMessage = messages[randomIndex].mensagem;
                    console.log(randomMessage);
                    // playIncentiveMessage(${displayMessage('LVELDOWN_MESSAGE_1'))
                    // playIncentiveMessage(${displayMessage('LVELDOWN_MESSAGE_1'), 9, '#9E0000')
                    playEventAlert2()
                    // playSound('Internal Level Down');
                    // playAnimation('Internal Level Down');
                    break;
                case 'Stage Up':
                    // Perform action for 'Stage Up'
                    playEventAlert3()
                    // playSound('Stage Up');
                    // playAnimation('Stage Up');
                    // playIncentiveMessage("Você ganhará mais mangos a cada nível!")
                    break;
                case 'Stage Down':
                    // Perform action for 'Stage Down'
                    playEventAlert4()
                    // playSound('Stage Down');
                    // playAnimation('Stage Down');
                    break;
                case 'Mangos':
                    // Perform action for 'Mangos'
                    playEventAlert5()
                    // playSound('mangos');
                    // playAnimation('mangos');
                    break;
                case 'Lower Head':
                    // Perform action for 'Lower Head'
                    playEventAlert6()
                    // playSound('Lower Head');
                    // playAnimation('Lower Head');
                    messages = general_msgs.lower_head;
                    randomIndex = Math.floor(Math.random() * messages.length);
                    randomMessage = messages[randomIndex].mensagem;
                    console.log(randomMessage);
                    break;
                case 'Raise Head':
                    // Perform action for 'Raise Head'
                    playEventAlert7()
                    // playSound('Raise Head');
                    // playAnimation('Raise Head');
                    messages = general_msgs.raise_head;
                    randomIndex = Math.floor(Math.random() * messages.length);
                    randomMessage = messages[randomIndex].mensagem;
                    console.log(randomMessage);
                    break;
    
                default:
                    // Optional: handle any other event types
                    break;
            }
        }
    }

    useEffect(() => {
        if (currentIncentiveMessageInfo.exibitionTime > 0) {
            // a cada um segundo, a função é chamada para descontar um segundo de exibitionTime
            const timer = setInterval(() => {
                setCurrentIncentiveMessageInfo((current) => ({
                    ...current,
                    exibitionTime: current.exibitionTime - 1
                }));
            }, 1000)
            //limpar temporizador
            return () => {
                clearInterval(timer)
            }
        } else {
            setCurrentIncentiveMessageInfo(initialIncentiveMessageInfo)
        }
    }, [currentIncentiveMessageInfo]);

    function playIncentiveMessage(incentiveMessage, exibitionTime, backgroundColor) {
        setCurrentIncentiveMessageInfo({
            incentiveMessage,
            exibitionTime,
            backgroundColor
        })
    }

    async function updateDialyOngoingDate() {
        setShowLoading(true)
        try {
            await api.dialy_controls.updateDialyOngoingDate(currentDialyControlData?.id)
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    } 

    const getCurrentDialy = async () => {
        setShowLoading(true)
        try {
            const { data } = !is_exercise_room ? await api.dialy_controls.listCurrents() : await api.dialy_controls.listExercising()
            setProgress((data.current_duration_formatted / 19) * 100)
            setCurrentDurationSection(data?.current_duration_formatted)
            setCurrentDialyControlData(data)
            if (!data) {
                setCurrentDurationSection(0)
            } 
            return data
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    async function handleOnFinish(currentDialy = null) {
        setShowLoading(true)
        try {
            const current_dialy = currentDialy ? currentDialy : currentDialyControlData
            const dialy_control = [{
                id: current_dialy?.id
            }]
            !is_exercise_room ? await api.dialy_controls.end(dialy_control) : await api.dialy_controls.finishExercise(dialy_control)
            setPatientDetected(false)
            finishTimer()
            await getCurrentDialy()
            open_lip = 0
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    async function handleOnStart() {
        setShowLoading(true)
        try {
            const body = {
                "patient_id": user && user?.id,
                "open_lip": 0,
                "camera_off": 0,
                "chewing": 0,
                "ended_at": 0,
                "exercise_done": 0,
                "camera_position": 0,
                "correct_execution": 0,
                "concentration_activity": 0,
            }
            !is_exercise_room ? await api.dialy_controls.create(body) : await api.dialy_controls.createInExercise(body)
            await getCurrentDialy()
            startTimer()
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    return (
        <div className={`w-full h-full flex ${windowWidth < 1000 ? 'flex-col' : 'flex-row'} justify-end ${isLandscapeOrMobileMode && 'landscape:h-64 landscape:mt-48'}`}>
        <div className={`h-full ${windowWidth > 1000 ? 'mr-5 w-[80%]' : 'w-full'} relative ${isLandscapeOrMobileMode && 'landscape:h-64 landscape:mt-48'}`}>
                <div className={`h-full w-full justify-center items-center flex ${isLandscapeOrMobileMode && 'landscape:h-64 landscape:mt-48'}`}>
                    {
                        currentDialyControlData &&
                        <>
                            <div className={`z-10 absolute top-0 left-0 p-3 ${mobile_mode ? 'text-base' : 'text-xl'} font-black ${isLandscapeOrMobileMode && 'landscape:text-base'}`} style={{color: tc2 }}>
                                Mangos: {currentMangos.toFixed(2)}
                            </div> 
                            <div className={`z-10 absolute top-0 right-0 ${mobile_mode ? 'text-base' : 'text-xl'} p-3 font-black ${isLandscapeOrMobileMode && 'landscape:text-base'}`} style={{color: tc2 }}>
                                {displayMessage('TOTAL_MINUTES_PASSED', [currentDurationSection])}
                            </div>
                            <div className={`z-10 absolute bottom-0 left-0 ${mobile_mode ? 'text-base' : 'text-xl'} p-3 font-black ${isLandscapeOrMobileMode && 'landscape:text-base'}`} style={{color: tc2 }}>
                                {displayMessage('QUANTITY_OPEN_LIP', [open_lip]) }
                            </div>
                            <div className={`z-10 absolute bottom-0 right-0 ${mobile_mode ? 'text-base' : 'text-xl'} p-3 font-black ${isLandscapeOrMobileMode && 'landscape:text-base'}`} style={{color: tc2 }}>
                                {displayMessage('STARS')}:
                                <span className='ml-2'>
                                    <Rate
                                        disabled
                                        value={!currentDialyControlData ? 0 : currentDialyControlData?.stars }
                                        count={3}
                                    />
                                </span>
                            </div>
                        </>
                    }
                <video ref={videoRef} className={`hidden absolute z-0 ${isLandscapeOrMobileMode && 'landscape:h-72'} h-full`} id="video" autoPlay={true} playsInline={true} muted={true}></video>
                <svg className='mb-20' id='svg-cam-off' fill="rgb(27,54,99)" width="64px" height="64px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" stroke="rgb(27,54,99)"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="m1421.141 2.417 91.775 64.262L215.481 1918.962l.595.416-.378.54-92.37-64.678L246.074 1680H0V240h1254.726L1421.141 2.416Zm79.395 278.487V678.89L1920 346.052v1228.01l-419.464-332.951V1680H520.538l76.895-109.78 793.325.001v-556.235l177.995 141.29 241.468 191.548V573.176l-241.468 191.662-177.995 141.29-.001-468.498 109.779-156.726Zm-322.705 68.874H109.779v1220.443h213.19l854.862-1220.443Z" fillRule="evenodd"></path> </g></svg>
            </div>
        </div>
    
        <div className={`${windowWidth < 1000 ? 'w-full' : 'w-[40%]'} ${mobile_mode ? 'h-36' : 'h-full'} flex gap-5 relative z-20`}>
            <div className={`bg-gray-100 h-full w-full flex justify-between`}>
                <div className={`flex flex-col justify-between w-full ${mobile_mode ? 'h-36' : 'h-full'} bg-white border`}>
                        <div style={{
                            display: 'flex',
                            padding: '10px',
                            backgroundColor: !patientDetected ? '#9E0000' : currentIncentiveMessageInfo?.backgroundColor
                    }}>
                        <span className='self-center font-medium text-white flex-1 text-center text-base'>{!patientDetected ? displayMessage('ERROR_PATIENT_NOT_DETECTED') : currentIncentiveMessageInfo?.incentiveMessage} </span>
                    </div>

                    <div className={`text-lg mt-2 mb-2 flex-col gap-3 mx-3.5`}>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {rules.length > 0 && rules.map((rule, stageIndex) => 
                            Array.from({ length: rule.niveis_internos }).map((_, internalIndex) => {
                                const isCurrentLevel = stageIndex < currentStage || (stageIndex === currentStage && internalIndex < currentInternalLevel);
                                const color = isCurrentLevel 
                                        ? rule.cor_rgb.join(',') 
//                                        : rule.cor_rgb.map(value => Math.min(255, value + 128)).join(','); // pale color if not current level
//                                        : rule.cor_rgb.reduce((a, b) => a + b, 0) / rule.cor_rgb.length; // gray color if not current level
                                      : rule.cor_rgb.map(value => Math.max(0, value - 192)).join(','); // dark color if not current level             
                                const totalSublevels = rules.reduce((total, rule) => total + rule.niveis_internos, 0);
                                const levelWidth = (statusbarLength / totalSublevels) - 4;
                                return (
                                    <div
                                        key={`${stageIndex}-${internalIndex}`}
                                        style={{
                                            backgroundColor: `rgb(${color})`,
                                            width: `${levelWidth}px`, // or any desired width
                                            height: '40px', // or any desired height
                                            margin: '1px',
                                        }}
                                    />
                                );
                            })
                        )}
                    </div>
                    <div>
                        Seconds: {currentSeconds}
                    </div>

                        <div style={{ backgroundColor: 'darkgrey' }}>
                             <input type="number" value={maximumLipDistance} onChange={handleChange} />
                        </div>
                    </div>
                    <div>
                        <Button
                            id='buttonStartAndFinish'
                            className={`w-full h-full font-bold text-lg text-white`}
                            style={{ backgroundColor: tc2 }}
                        >
                            {!currentDialyControlData ? displayMessage('START_MONITORY_EXERCISE') : displayMessage('FINISH')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}




// const jsonRules = `{
//     "etapas": [
//         {
//             "cor_rgb": [255, 0, 0],
//             "ordem": 1,
//             "niveis_internos": 6,
//             "tempo_por_etapa_em_segundos": 15,
//             "quantidade_de_mangos_por_etapa": 0.2,
//             "quantidade_de_erros_para_cair_de_etapa": 1
//         },
//         {
//             "cor_rgb": [165, 42, 42],
//             "ordem": 2,
//             "niveis_internos": 5,
//             "tempo_por_etapa_em_segundos": 36,
//             "quantidade_de_mangos_por_etapa": 0.4,
//             "quantidade_de_erros_para_cair_de_etapa": 1
//         },
//         {
//             "cor_rgb": [255, 255, 0],
//             "ordem": 3,
//             "niveis_internos": 4,
//             "tempo_por_etapa_em_segundos": 60,
//             "quantidade_de_mangos_por_etapa": 0.6,
//             "quantidade_de_erros_para_cair_de_etapa": 1
//         },
//         {
//             "cor_rgb": [255, 165, 0],
//             "ordem": 4,
//             "niveis_internos": 3,
//             "tempo_por_etapa_em_segundos": 120,
//             "quantidade_de_mangos_por_etapa": 0.8,
//             "quantidade_de_erros_para_cair_de_etapa": 1
//         },
//         {
//             "cor_rgb": [0, 128, 0],
//             "ordem": 5,
//             "niveis_internos": 2,
//             "tempo_por_etapa_em_segundos": 120,
//             "quantidade_de_mangos_por_etapa": 1,
//             "quantidade_de_erros_para_cair_de_etapa": 1
//         }
//     ]
// }`;


{/* <div>
<label>
    Use Object Detection:
    <input
    type="checkbox"
    checked={shouldUseObjectDetection}
    onChange={() => setShouldUseObjectDetection(!shouldUseObjectDetection)}
    />
</label>
</div> */}






